

import EndPointConfig from '../../models/api/EndPointConfig'

const controller = 'Bookings'

export const BookingsEP : EndPointConfig[] =[
        new EndPointConfig()
        .setMethod("GET")
        .setController(controller)
        .setActionName("GetBooking"),
        new EndPointConfig()
        .setMethod("GET")
        .setController(controller)
        .setActionName("FilterBookings"),
        new EndPointConfig()
        .setMethod("POST")
        .setController(controller)
        .setActionName("ImportBookingRewards"),

         new EndPointConfig()
        .setMethod("POST")
        .setController(controller)
        .setActionName("CancelBookingRewards"),

         new EndPointConfig()
        .setMethod("POST")
        .setController(controller)
        .setActionName("CreatePendingBooking"), 

        new EndPointConfig()
        .setMethod("GET")
        .setController(controller)
        .setActionName("GetBookingStatus"),

        new EndPointConfig()
        .setMethod("POST")
        .setController(controller)
        .setActionName("ChangeBookingStatus"),

        new EndPointConfig()
        .setMethod("GET")
        .setController(controller)
        .setActionName("GetRequestDataToPreAuthorizationPayment") ,

        new EndPointConfig()
        .setMethod("DELETE")
        .setController(controller)
        .setActionName("DeleteBooking") ,

        new EndPointConfig()
        .setMethod("POST")
        .setController(controller)
        .setActionName("SendBookingDetailsEmail") ,

]